import React, { FC, useMemo } from 'react'
import useLanguage from 'hooks/useLanguage'
import { useTranslation } from 'react-i18next'
import { displayPrice2Digit } from 'helpers'
import { Adjustments, TitleRegular, AdjustmentTotal } from './checkoutStyled'
import { AdjustmentTypeEnumType, PromotionTypeEnum } from 'graphQL/dinein/generate/operations'
import { Icon } from 'components/base-ui'

export interface Adjustment {
  id: number
  labelEn: string
  labelTh: string
  amountSatangs: number
  adjustmentType: AdjustmentTypeEnumType
  promotion: { type: PromotionTypeEnum; descriptionEn: string; descriptionTh: string }
}

export interface AutoPromotion {
  name: string
  description: string
}

type Props = {
  adjustments: Adjustment[]
  handleClickAutoPromotion: (autoPromotion: AutoPromotion) => void
}

const OrderAdjustment: FC<Props> = ({ adjustments, handleClickAutoPromotion }) => {
  const { getPropertyByLang } = useLanguage()
  const { t } = useTranslation()

  const orderAdjustments = useMemo(() => {
    return adjustments
      ?.filter(
        ({ adjustmentType, amountSatangs, ...adjustment }) =>
          (adjustmentType === AdjustmentTypeEnumType.Discount ||
            adjustmentType === AdjustmentTypeEnumType.Concession ||
            adjustment.promotion?.type === PromotionTypeEnum.Auto) &&
          amountSatangs !== 0
      )
      .map((adjustment) => {
        const {
          id,
          amountSatangs,
          labelEn,
          labelTh,
          promotion: { descriptionEn, descriptionTh, type },
        } = adjustment
        const label = getPropertyByLang({ en: labelEn ? labelEn : t('checkoutSummaryDiscounts'), th: labelTh })
        const description = getPropertyByLang({ en: descriptionEn, th: descriptionTh })
        return {
          id,
          label,
          amountSatangs,
          description,
          type,
        }
      })
  }, [adjustments, getPropertyByLang, t])

  return (
    <>
      {orderAdjustments.map(({ id, label, amountSatangs, description, type }) => {
        const isAutoPromotion = type === PromotionTypeEnum.Auto
        return (
          <Adjustments
            key={id}
            onClick={() => isAutoPromotion && handleClickAutoPromotion({ name: label, description })}
            className="adjustment-item"
          >
            <TitleRegular className="adjustment-label">
              {label} {isAutoPromotion && <Icon name="information" color="#1562A8" />}
            </TitleRegular>
            <AdjustmentTotal className="adjustment-discount">
              {amountSatangs < 0
                ? `-${displayPrice2Digit(amountSatangs / 100).replace('-', '')}`
                : `${displayPrice2Digit(amountSatangs / 100)}`}
            </AdjustmentTotal>
          </Adjustments>
        )
      })}
    </>
  )
}

export default OrderAdjustment
